/**
 * Tone → Tailwind utility map.
 *
 * Typography components accept a `tone` prop which resolves to a token-backed
 * Tailwind utility (`text-text`, `text-text-muted`, …). The token CSS vars
 * are defined in `src/app/globals.css` under :root and .dark.
 */

export type Tone =
  | 'default'
  | 'muted'
  | 'subtle'
  | 'inverse'
  | 'accent'
  | 'danger'
  | 'success'
  | 'warning'
  | 'info'

export const toneClass: Record<Tone, string> = {
  default: 'text-text',
  muted: 'text-text-muted',
  subtle: 'text-text-subtle',
  inverse: 'text-text-inverse',
  accent: 'text-accent',
  danger: 'text-danger',
  success: 'text-success',
  warning: 'text-warning',
  info: 'text-info',
}

export type FontFamily = 'display' | 'sans' | 'mono'

/** Accepted by the `font` prop on every typography primitive. `'inherit'`
 *  emits no `font-*` class so the parent's font wins (use this when wrapping
 *  a typographic island in a `font-display` / `font-sans` div). */
export type FontProp = FontFamily | 'inherit'

export const fontClass: Record<FontFamily, string> = {
  display: 'font-display',
  sans: 'font-sans',
  mono: 'font-mono',
}

/** Resolve a `font` prop to a single Tailwind utility (or '' for inherit). */
export function resolveFontClass(font: FontProp): string {
  return font === 'inherit' ? '' : fontClass[font]
}
